<nav
  #scroller
  class="subnav"
  [class.subnav--hidden-before]="hiddenBefore()"
  [class.subnav--hidden-after]="hiddenAfter()"
  (scroll)="measure()"
  aria-label="Browse categories"
>
  @if (tenantScope.tenant(); as tenant) {
    <a
      class="subnav-link hot"
      [routerLink]="['/retailer', tenant.slug, 'search']"
      [queryParams]="{ fulfilment: 'pickup' }"
      routerLinkActive="is-active"
      ariaCurrentWhenActive="page"
      [routerLinkActiveOptions]="linkActiveOptions"
    >
      <app-icon name="map-pin" [size]="14" />
      Local Pickup
    </a>
    <a
      class="subnav-link"
      [routerLink]="['/retailer', tenant.slug, 'search']"
      [queryParams]="{ sort: 'ending-soon' }"
      routerLinkActive="is-active"
      ariaCurrentWhenActive="page"
      [routerLinkActiveOptions]="linkActiveOptions"
    >
      Ending Soon
    </a>
    @if (status() === 'loading') {
      @for (width of categoryPlaceholders; track width) {
        <app-skeleton class="subnav-placeholder" variant="rect" [width]="width" height="14px" aria-hidden="true" />
      }
    }
    @for (category of categories(); track category.slug) {
      <a
        class="subnav-link"
        [routerLink]="['/retailer', tenant.slug, 'search']"
        [queryParams]="{ category: category.slug }"
        routerLinkActive="is-active"
        ariaCurrentWhenActive="page"
        [routerLinkActiveOptions]="linkActiveOptions"
      >
        {{ category.name }}
      </a>
    }
    <a class="subnav-link subnav-link--navy push-end" [routerLink]="['/retailer', tenant.slug]" fragment="stores">
      Our Stores
    </a>
    <a class="subnav-link subnav-link--accent" routerLink="/favorites" [queryParams]="{ tab: 'hunts' }">My Hunts</a>
  } @else {
    <a
      class="subnav-link hot"
      routerLink="/search"
      [queryParams]="{ fulfilment: 'pickup' }"
      routerLinkActive="is-active"
      ariaCurrentWhenActive="page"
      [routerLinkActiveOptions]="linkActiveOptions"
    >
      <app-icon name="map-pin" [size]="14" />
      Local Finds
    </a>
    <a
      class="subnav-link"
      routerLink="/search"
      [queryParams]="{ sort: 'ending-soon', format: 'auction' }"
      routerLinkActive="is-active"
      ariaCurrentWhenActive="page"
      [routerLinkActiveOptions]="linkActiveOptions"
    >
      Ending Soon
    </a>
    @if (status() === 'loading') {
      @for (width of categoryPlaceholders; track width) {
        <app-skeleton class="subnav-placeholder" variant="rect" [width]="width" height="14px" aria-hidden="true" />
      }
    }
    @for (category of categories(); track category.slug) {
      <a
        class="subnav-link"
        routerLink="/search"
        [queryParams]="{ category: category.slug }"
        routerLinkActive="is-active"
        ariaCurrentWhenActive="page"
        [routerLinkActiveOptions]="linkActiveOptions"
      >
        {{ category.name }}
      </a>
    }
  }
</nav>
